export default "__VITE_ASSET__CPBRY51c__"